import { render } from "./Data.vue?vue&type=template&id=4973b7e0"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"
script.render = render

export default script